module.exports = __webpack_public_path__ + "static/tcdd-dev-393c927fe3ebe45e3e2ffb331cca2bbe.png";